import { isNil } from "lodash";

import VerticalDivider from "@components/VerticalDivider";
import TableHeaderNavigationButton from "./TableHeaderNavigationButton";

type Props = {
  disabled: boolean;
  prev?: string | number;
  next?: string | number;
  onClick: (next: string | number) => void;
};

const PageIdNavigation = ({ disabled, prev, next, onClick }: Props) => {
  const handlePrevClick = () => {
    if (disabled || isNil(prev)) return;
    onClick(prev);
  };

  const handleNextClick = () => {
    if (disabled || !next) return;
    onClick(next);
  };

  return (
    <div className="flex align-center flex-gap-3">
      <TableHeaderNavigationButton
        data-testid="table_header_back_button"
        disabled={isNil(prev) || disabled}
        icon="chevron-left"
        onClick={handlePrevClick}
      />
      <VerticalDivider />
      <TableHeaderNavigationButton
        data-testid="table_header_forward_button"
        disabled={!next || disabled}
        icon="chevron-right"
        onClick={handleNextClick}
      />
    </div>
  );
};

export default PageIdNavigation;
